export default __webpack_public_path__ + "static/media/step6DarkMode.d4291b58.svg";